
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clenstvi-podminky",
      function () {
        return require("private-next-pages/clenstvi-podminky.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clenstvi-podminky"])
      });
    }
  